import { ClareSystem } from "@app/project/model/clare-system";
import { ActionPayloadGeneric } from "@app/root-store/actions";
import { createActionSet } from "@app/root-store/actions/action-creators";

const actionCategory = "ClareSystem";

type ActionPayload = { claresystem: ClareSystem } & ActionPayloadGeneric;
interface ActionResult {
    claresystem: ClareSystem;
}

export const {
    request: create,
    success: createSuccess,
    failure: createFailure,
} = createActionSet<ActionPayload, ActionResult>(actionCategory, "Create");

export const {
    request: update,
    success: updateSuccess,
    failure: updateFailure,
} = createActionSet<ActionPayload, ActionResult>(actionCategory, "Update");
